export const SWISS_FRANC = 'CHF';
